import request from '@/utils/request'

export function getSdk(url) {
  return request({
    url: "https://wx.xchengtech.cn/saas/getJssdk",
    method: 'post',
    data: {
      url: url
    }
  })
}

// 更新微信用户信息
export function updateWxInfo(data) {
  return request({
    url: "api/updateWxInfo",
    method: 'post',
    data
  })
}

// 发送错误日志
export function fillLog(data) {
  return request({
    url: "cus/fill/log",
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/wx.js